import { createPortal } from 'react-dom';

import * as S from './styles';

const CURSOR_OFFSET = 16;
const VIEWPORT_MARGIN = 8;
const MAX_WIDTH = 320;
const MAX_HEIGHT = 120;

export interface MouseTooltipProps {
  x: number;
  y: number;
  title: string;
  description?: string;
}

const clamp = (value: number, min: number, max: number): number => {
  if (max < min) {
    return min;
  }
  return Math.min(Math.max(value, min), max);
};

export const MouseTooltip = ({
  x,
  y,
  title,
  description,
}: MouseTooltipProps) => {
  if (typeof document === 'undefined') {
    return null;
  }

  const left = clamp(
    x + CURSOR_OFFSET,
    VIEWPORT_MARGIN,
    window.innerWidth - MAX_WIDTH - VIEWPORT_MARGIN
  );
  const top = clamp(
    y + CURSOR_OFFSET,
    VIEWPORT_MARGIN,
    window.innerHeight - MAX_HEIGHT - VIEWPORT_MARGIN
  );

  return createPortal(
    <S.Tooltip role="tooltip" style={{ left, top }}>
      <S.Title>{title}</S.Title>
      {description ? <S.Description>{description}</S.Description> : null}
    </S.Tooltip>,
    document.body
  );
};
